import { z } from "zod";
import { entitlementSchema } from "./entitlement.js";
import { isoDateTimeSchema, userProfileSchema } from "./profile.js";
export const apiErrorCodeSchema = z.enum([
    "UNAUTHENTICATED",
    "RECENT_AUTH_REQUIRED",
    "PERMISSION_DENIED",
    "NOT_FOUND",
    "CONFLICT",
    "INVALID_ARGUMENT",
    "VALIDATION_ERROR",
    "PAYLOAD_TOO_LARGE",
    "RATE_LIMITED",
    "UNAVAILABLE",
    "INTERNAL",
]);
/** Standard error envelope returned by the control API. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: apiErrorCodeSchema,
        message: z.string().min(1),
        details: z.unknown().optional(),
    }),
});
export const healthResponseSchema = z.object({
    status: z.literal("ok"),
    service: z.literal("control-api"),
    timestamp: isoDateTimeSchema,
});
export const readyResponseSchema = z.object({
    status: z.literal("ready"),
    service: z.literal("control-api"),
    checks: z.array(z.object({
        name: z.string().min(1),
        ok: z.boolean(),
    })),
    timestamp: isoDateTimeSchema,
});
export const meResponseSchema = z.object({
    user: userProfileSchema,
    entitlement: entitlementSchema,
    accessRequested: z.boolean().default(false),
});
//# sourceMappingURL=api.js.map